// extracted by mini-css-extract-plugin
export var boldText = "_85-4";
export var checkboxContainer = "_85-6";
export var closeIcon = "_85-i";
export var container = "_85-0";
export var drawer = "_85-8";
export var drawerContent = "_85-9";
export var extraSmallText = "_85-5";
export var fulfillmentGroupTable = "_85-e";
export var largeText = "_85-3";
export var loadingSpinnerContainer = "_85-j";
export var mediumText = "_85-2";
export var narrow = "_85-f";
export var notificationLink = "_85-l";
export var packageCheckIconContainer = "_85-7";
export var slideoutHeaderActions = "_85-g";
export var slideoutHeaderActionsShifted = "_85-h";
export var slideoutHeaderContainer = "_85-a";
export var slideoutModal = "_85-c";
export var stickyHeaderWrapper = "_85-b";
export var table = "_85-k";
export var tableContainer = "_85-d";
export var tertiaryText = "_85-1";